import React from 'react';
import { HeadingThree as HeadingThreeDesign } from '@marty-js/design/src/atoms/h3';
import type { HeadingData, PluginComponent } from './types';

export const HeadingThree: PluginComponent = ({ children, data }) => {
  const headingData = data as HeadingData;

  return <HeadingThreeDesign id={headingData?.index}>{children}</HeadingThreeDesign>;
};
